module.exports = __webpack_public_path__ + "assets/img/technology.6a04d2f3.png";